//
// Custom module settings
// ----------------------

export default {
	// Point this instance of the web files at a remote DAM or proxy
	/*DAM_URL: "http://your.remote.dam",*/

	//API: '1.1',

	// Is a login required?  (Default true)
	/*REQUIRE_LOGIN: false,*/

	// Length of the console history log; to disable, set to zero.
	CONSOLE_HISTORY_LENGTH: 0,

	// Display misc RPC exceptions to the user?  (Default is false.)
	// SHOW_RPC_ALERT: true,

	// If HOME_ROUTE is set the app will fire its value as the startup route
	HOME_ROUTE: 'dashboard',

	// If TIME_RENDERS is set, the app will log to the console the elapsed time in ms for every view.render() call.
	// TIME_RENDERS: true,
};
